module.exports = __webpack_public_path__ + "static/media/Menu-8.20394433.jpg";